import ModalConfigure from './ModalConfigure';

export default ModalConfigure;
